import { render, staticRenderFns } from "./AppTaskQuestionnaire.vue?vue&type=template&id=54c82ea5"
import script from "./AppTaskQuestionnaire.vue?vue&type=script&lang=js"
export * from "./AppTaskQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports